import React from 'react';

import styled from '../../styled-components';

const MissingPropsPlaceholder = ({ text }: { text: string }) => (
  <MessageWrapper title={text}>
    <Message>{text}</Message>
  </MessageWrapper>
);

const MessageWrapper = styled.div.attrs({
  className: `input-missingprops-message`,
})`
  border: 1px solid red;
  text-align: left;
  width: 100%;
  white-space: nowrap;
`;

const Message = styled.p`
  background: #efefef;
  color: red;
  font-weight: normal;
  margin: 0;
  padding: 5px 10px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default MissingPropsPlaceholder;
